import { useNavigate, useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Speelschemas } from "@/features/stamgegevens/Speelschemas";
import { BeheerderShell } from "@/components/BeheerderShell";
import { keepScrollPosition } from "@jbnl/shared-ui";

export function SpeelschemasPage() {
  const { t } = useTranslation(["paginas", "navigatie"]);
  const { niveau: niveauId, tab } = useSearch({
    from: "/stamgegevens/speelschemas",
  });
  const navigate = useNavigate({ from: "/stamgegevens/speelschemas" });

  return (
    <BeheerderShell
      titel={t("navigatie:paginas.speelschemas.label")}
      uitleg={t("speelschemas.uitleg")}
    >
      <Speelschemas
        niveauId={niveauId}
        // The chosen klasse rides along rather than being wiped: a klasse is the same record at
        // every niveau, so a beheerder comparing one klasse across niveaus keeps their place.
        onKies={(id) =>
          void navigate({
            ...keepScrollPosition,
            search: (previous) => ({ ...previous, niveau: id }),
          })
        }
        tab={tab}
        onKiesTab={(next) =>
          void navigate({
            ...keepScrollPosition,
            replace: true,
            search: (previous) => ({ ...previous, tab: next }),
          })
        }
      />
    </BeheerderShell>
  );
}
